"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(theme, props) {
  var palette = theme.palette,
      cursor = 'pointer',
      appearanceMargin = theme.appearanceMargin;

  if (props.checked) {
    theme.color = theme.checkedColor;
  }

  if (props.disabled) {
    cursor = 'not-allowed';
    theme.color = theme.disabledColor;
    theme.hoverColor = theme.disabledColor;
  }

  if (props.error) {
    theme.color = theme.errorColor;
  }

  if (!props.children && !props.label) {
    appearanceMargin = 0;
  }

  return {
    root: {
      fontFamily: theme.fontFamily,
      display: theme.display,
      fontSize: theme.fontSize,
      lineHeight: theme.lineHeight
    },
    wrapper: {
      position: 'relative'
    },
    field: {
      display: 'none'
    },
    label: {
      transition: "all ".concat(palette.transitionDuration, " ").concat(palette.transitionFunction),
      color: theme.color,
      whiteSpace: theme.whiteSpace,
      wordWrap: theme.wordWrap,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexDirection: 'row',
      width: '100%',
      cursor: cursor,
      '&:hover': {
        color: theme.hoverColor
      }
    },
    labelText: {
      paddingTop: theme.paddingTop,
      paddingBottom: theme.paddingBottom,
      paddingLeft: theme.paddingLeft,
      paddingRight: theme.paddingRight,
      fontSize: theme.fontSize,
      lineHeight: theme.lineHeight,
      textAlign: 'left',
      flex: 1,
      overflow: theme.overflow,
      textOverflow: theme.textOverflow
    },
    iconWrapper: {
      margin: appearanceMargin,
      flexBasis: '24px',
      flexShrink: 0
    }
  };
}